export const LEGAL_OPERATOR = {
  name: "Резник Виктор Вячеславович",
  shortName: "Резник В.В.",
  status: "самозанятый",
  inn: "772880923142",
  email: "support@club-lab.ru",
  telegram: "@MoGame_Support",
  telegramUrl: "https://t.me/MoGame_Support",
};

export const LEGAL_SITE = {
  name: "MOGAME",
  url: "https://club-lab.ru/",
};

export const LEGAL_REVISION = "29.06.2026";

export const LEGAL_DOCUMENT_LINKS = [
  { label: "Правила сервиса", href: "/main/rules" },
  { label: "Публичная оферта", href: "/oferta" },
  { label: "Политика конфиденциальности", href: "/politic-confidencial" },
];

export const LEGAL_PUBLIC_LINKS = [
  { label: "Публичная оферта", href: "/oferta" },
  { label: "Политика конфиденциальности", href: "/politic-confidencial" },
];

export const YOOKASSA = {
  name: "ЮKassa",
  legalName: "ООО НКО «ЮMoney»",
  inn: "7750009840",
  ogrn: "1147746000613",
  address: "121099, г. Москва, пер. Новинский, д. 8, пом. 1",
};
